import { db } from "@/api/firebase";
import { City } from "@/models/City";
import { Game } from "@/models/Game";
import { GameError } from "@/models/Errors/GameError";
import { Season } from "@/models/GameType";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { Quests } from "@/models/MapPois/Quest/Quests";
import { isEmpty, isEqual, toArray } from "lodash";
import QuestMapErrors from "./QuestMapErrors";
import QuestPoiError from "./QuestPoiErrors";
import QuestMapWarnings from "./QuestMapWarning";
import QuestPoiWarnings from "@/utils/ErrorQuest/QuestPoiWarnings";
export default class QuestGameErrors {
  mapPoi: QuestMapPoi[];
  questData: Quests[];
  gameUid: string;
  cityData: City;
  seasonData: Season;
  gameData: Game[];
  errorObject = {} as GameError;

  constructor(
    gameUid: string,
    mapPoi: QuestMapPoi[],
    questData: Quests[],
    cityData: City,
    seasonData: Season,
    gameData: Game[]
  ) {
    this.mapPoi = mapPoi;
    this.gameUid = gameUid;
    this.cityData = cityData;
    this.questData = questData;
    this.seasonData = seasonData;
    this.gameData = gameData;
  }

  checkGameErrors(): GameError {
    this.checkAllMapPoiErrors();
    this.checkAllMapPoiWarning();
    this.checkAllQuestWarning();
    this.checkAllQuestErrors();
    this.countErrorIssues();
    this.countQuestIssues();
    if (!isEmpty(this.errorObject)) {
      db.ref("games/" + this.gameUid + "/issues/err/").set(this.errorObject);
    } else {
      db.ref("games/" + this.gameUid + "/issues/err/").remove();
    }
    return this.errorObject;
  }

  private countErrorIssues(): void {
    let count = 0;
    this.mapPoi.forEach((x: QuestMapPoi) => {
      if (x.issues?.err !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.errorObject.error_count = {
        active: true,
        txt: { en: "POI Error: " + count + " POIs with Errors" },
        count: count,
      };
    } else {
      if (this.errorObject.error_count !== undefined) {
        delete this.errorObject.error_count;
      }
    }
  }

  private countQuestIssues(): void {
    let count = 0;
    this.questData.forEach((x: Quests) => {
      if (x.issues?.err !== undefined) {
        count++;
      }
    });
    if (count > 0) {
      this.errorObject.quest_error_count = {
        active: true,
        txt: { en: "Quest Error: " + count + " Quests with Errors" },
        count: count,
      };
    } else {
      if (this.errorObject.quest_error_count !== undefined) {
        delete this.errorObject.quest_error_count;
      }
    }
  }

  private checkAllMapPoiErrors(): void {
    this.mapPoi.forEach((x: QuestMapPoi) => {
      new QuestPoiError(
        x,
        this.gameUid,
        this.mapPoi,
        this.questData,
        this.seasonData
      ).checkQuestMapPoiErrors();
    });
  }
  private checkAllMapPoiWarning(): void {
    this.mapPoi.forEach((x: QuestMapPoi) => {
      new QuestPoiWarnings(
        this.gameUid,
        x,
        this.gameData
      ).checkMapPoiWarningErrors();
    });
  }
  private checkAllQuestErrors(): void {
    this.questData.forEach((x: Quests) => {
      const errorObject = new QuestMapErrors(
        this.gameUid,
        x
      ).checkQuestErrors();
      if (!isEmpty(errorObject)) {
        x.issues = { err: errorObject };
      }
    });
  }
  private checkAllQuestWarning(): void {
    this.questData.forEach((x: Quests) => {
      new QuestMapWarnings(
        this.gameUid,
        x,
        this.gameData
      ).checkQuestWarningErrors();
    });
  }
}
